import { render } from "./level_2.svg?vue&type=template&id=6e08e68f"
const script = {}
script.render = render

export default script